import * as React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

interface CustomNumberInputProps {
  label: string;
  value: string | number | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  disabled?: boolean;
  allowOnlyPositive?: boolean;
  dataCy?: string;
}

const CustomNumberInput: React.FC<CustomNumberInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  allowOnlyPositive = false,
  dataCy,
}) => {
  const [error, setError] = React.useState<string | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
  
    const decimalRegex = /^-?\d*\.?\d*$/;
  
    if (newValue === "") {
      setError(null);
      onChange(event);
      return;
    }
  
    if (!decimalRegex.test(newValue)) {
      setError("Solo se permiten números y un punto decimal.");
      return;
    }
  
    setError(null);
    onChange(event);
  };  

  const formattedValue = () => {
    if (typeof value === "number") {
      return Number.isNaN(value) ? "" : value.toString();
    }
    if (typeof value === "string") {
      return value;
    }
    return "";
  };

  return (
    <FormControl fullWidth margin="none">
      <TextField
        error={Boolean(error)}
        label={label}
        value={formattedValue()}
        type="text"
        required={required}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        helperText={error}
        inputProps={{ 'data-cy': dataCy }}
      />
    </FormControl>
  );
};

export default CustomNumberInput;
